import React from "react"
import { fetchCampaign } from "../../services/dataStore"
import { filterEmptyValues } from "../../helpers/filterEmptyValues"
import { SignupForm } from "../SignupForm"

import {
  PROMO_CODE_COOKIE,
  COOKIE_DOMAIN,
} from "../../constants/cookies"

const Cookies = require("js-cookie")

interface CampaignLandingProps extends CampaignLandingState {
  allowFetchData?: boolean,
  buttonColor?: string,
  buttonTextColor?: string,
  buttonHoverColor?: string,
  buttonActiveColor?: string,
  textColor?: string,
  backgroundColor?: string,
  textBackgroundColor?: string
}

interface CampaignLandingState {
  callToAction?: string,
  code?: string,
  headline?: string,
  offerLine1?: string,
  subHeadline?: string,
  welcomeMessage?: string,
}

interface FetchDataParams {
  retry?: boolean,
  code?: string,
}

class CampaignLandingInner extends React.Component<
  CampaignLandingProps,
  CampaignLandingState> {
  public static defaultProps = {
    allowFetchData: false,
    callToAction: "Get Cooking!",
    code: "",
    headline: "Make Dinner in 15 Minutes",
    offerLine1: "Get started with Gobble today:",
    subHeadline: "",
    welcomeMessage: "Gobble's chefs do all the prep work, like peeling, chopping & marinating, so you can cook a fresh homemade dinner in just 15 minutes.",
    textHighlightColor: null,
  }

  constructor(props: CampaignLandingProps) {
    super(props)
    this.state = {
      callToAction: props.callToAction,
      code: "",
      headline: "",
      offerLine1: "",
      subHeadline: "",
      welcomeMessage: "",
    }
  }

  componentDidMount() {
    const { allowFetchData } = this.props
    const code = this.getPromoCode()
    this.setDefaultState()

    if (code && allowFetchData) {
      this.fetchData({ code })
    }
  }

  private setDefaultState(): void {
    this.setState({ ...this.props })
  }

  private getPromoCode(): string {
    const { code } = this.props
    const cookieCode: string = Cookies.get(PROMO_CODE_COOKIE, { domain: COOKIE_DOMAIN })
    return cookieCode || code
  }

  private async fetchData({ code }: FetchDataParams) {
    try {
      const query = `
        headline
        offerLine1
        subHeadline
        welcomeMessage
        callToAction
        code
      `
      let campaign = await fetchCampaign(query, code)
      campaign = filterEmptyValues(campaign)
      this.setState({ ...campaign })
    } catch (error) {
      console.log(error)
    }
  }

  renderFormattedText(text) {
    if (!text) {
      return
    }

    const { textBackgroundColor } = this.props

    if (!textBackgroundColor) {
      return text
    }

    let splitText = text.split(" ")
    splitText = splitText.map((word) => `<span aria-hidden="true" class="inline-block" style="padding: 0.1em 0.15em; background-color: ${textBackgroundColor}">${word}</span>`)
    const accessibleText = `<p class="sr-only">${text}</p>`
    return accessibleText + splitText.join("")
  }

  render() {
    const {
      callToAction,
      code,
      headline,
      offerLine1,
      subHeadline,
      welcomeMessage,
    } = this.state

    const {
      buttonColor,
      buttonTextColor,
      buttonHoverColor,
      buttonActiveColor,
      textColor,
      backgroundColor,
    } = this.props

    return (
      <div className="flex w-full justify-between">
        <div className="w-full lg:w-7/12 lg:pr-10 self-center lg:max-w-2xl">
          <h1 className="text-5xl font-bold mb-4 leading-none" role="text" dangerouslySetInnerHTML={{ __html: this.renderFormattedText(headline) }} />
          <div className="text-2xl font-semibold mb-4 leading-tight" role="text" dangerouslySetInnerHTML={{ __html: this.renderFormattedText(subHeadline) }} />
          <div className="text-lg" role="text" dangerouslySetInnerHTML={{ __html: this.renderFormattedText(welcomeMessage) }} />
        </div>

        <div className="hidden lg:block w-5/12 max-w-96" style={{ maxWidth: 384 }}>
          <SignupForm
            cta={callToAction}
            title={offerLine1}
            code={code}
            buttonColor={buttonColor}
            buttonTextColor={buttonTextColor}
            buttonHoverColor={buttonHoverColor}
            buttonActiveColor={buttonActiveColor}
            textColor={textColor}
            backgroundColor={backgroundColor}
          />
        </div>
      </div>
    )
  }
}

export function CampaignLanding(props: CampaignLandingProps) {
  return <CampaignLandingInner {...props} />
}
